"use strict";

require("core-js/modules/es.array.sort.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stationMatchesUserInput = exports.sortStations = exports.parseSuggestions = exports.parseItems = exports.getStationObjectFromCode = exports.getRecentSearches = exports.getIcon = exports.getDestinationAirportsObject = exports.getDestinationAirportsList = exports.formatStationObject = exports.formatStationDisplayName = exports.fetchStationObject = exports.checkIfValidStation = exports.addRecentSearchLabelIcon = exports.addNearestAirportLocationIcon = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = require("lodash");

var _constant = require("../constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var sortStations = function sortStations(stationList, isFiltered) {
  if (isFiltered) {
    stationList.sort(function (a, b) {
      return a.Priority - b.Priority || a.StationName.localeCompare(b.StationName);
    });
  } else {
    stationList.sort(function (a, b) {
      return a.StationName.localeCompare(b.StationName);
    });
  }

  return stationList;
}; // eslint-disable-next-line consistent-return


exports.sortStations = sortStations;

var stationMatchesUserInput = function stationMatchesUserInput(obj, input) {
  if (!obj || !obj.StationName || !obj.StationCode) return false;
  var st = {
    StationName: obj.StationName.toLowerCase(),
    StationCode: obj.StationCode.toLowerCase(),
    PinYin: (obj.PinYin || '').toLowerCase(),
    AlternativeName: (obj.AlternativeName || '').toLowerCase(),
    AirportName: (obj.AirportName || '').toLowerCase(),
    CountryName: (obj.CountryName || '').toLowerCase()
  }; // eslint-disable-next-line default-case

  switch (true) {
    case st.StationName.startsWith(input):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 0;
      return true;

    case st.StationCode.startsWith(input):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 1;
      return true;

    case st.PinYin.startsWith(input):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 2;
      return true;

    case st.StationName.split(' ').some(function (val) {
      return val.startsWith(input);
    }):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 3;
      return true;

    case st.AlternativeName.startsWith(input):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 4;
      return true;

    case st.AlternativeName.split(' ').some(function (val) {
      return val.startsWith(input);
    }):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 5;
      return true;

    case st.AirportName.startsWith(input):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 6;
      return true;

    case st.AirportName.split(' ').some(function (val) {
      return val.startsWith(input);
    }):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 7;
      return true;

    case st.CountryName.startsWith(input):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 8;
      return true;

    case st.CountryName.split(' ').some(function (val) {
      return val.startsWith(input);
    }):
      // eslint-disable-next-line no-param-reassign
      obj.Priority = 9;
      return true;
  }
};

exports.stationMatchesUserInput = stationMatchesUserInput;

var getIcon = function getIcon(StationType) {
  switch (StationType.toUpperCase()) {
    case _constant.STATION_TYPES.AIR_PORTS:
      return _constant.STATION_ICONS.AIR_PORTS_ICON;

    case _constant.STATION_TYPES.FERIES:
      return _constant.STATION_ICONS.FERIES_ICON;

    case _constant.STATION_TYPES.HOTEL_OR_BUSES:
      return _constant.STATION_ICONS.HOTEL_OR_BUSES_ICON;

    default:
      return '';
  }
};

exports.getIcon = getIcon;

var addNearestAirportLocationIcon = function addNearestAirportLocationIcon(stationList) {
  var nearestAirports = [];
  stationList.forEach(function (station) {
    var newObj = _objectSpread({}, station);

    newObj.iconName = _constant.STATION_ICONS.LOCATION_ON_ICON;
    nearestAirports.push(newObj);
  });
  return nearestAirports;
};

exports.addNearestAirportLocationIcon = addNearestAirportLocationIcon;

var addRecentSearchLabelIcon = function addRecentSearchLabelIcon(stationList) {
  var recentSearchStations = [];
  stationList.forEach(function (station) {
    var newObj = _objectSpread({}, station);

    newObj.iconName = _constant.STATION_ICONS.RECENT_SEARCH_ICON;
    recentSearchStations.push(newObj);
  });
  return recentSearchStations;
};

exports.addRecentSearchLabelIcon = addRecentSearchLabelIcon;

var formatStationObject = function formatStationObject(station) {
  return _objectSpread(_objectSpread({}, station), {}, {
    mainDisplayName: "".concat(station.StationName),
    iconName: getIcon(station.StationType),
    airportCode: station.StationCode,
    carrier: station.AAFlight === true ? 'AAI' : 'KIWI'
  });
};

exports.formatStationObject = formatStationObject;

var parseItems = function parseItems(items) {
  return items.map(function (suggestion) {
    return suggestion !== null && formatStationObject(suggestion);
  }).filter(function (_ref) {
    var iconName = _ref.iconName;
    return iconName !== '';
  });
};

exports.parseItems = parseItems;

var formatStationDisplayName = function formatStationDisplayName(station) {
  return _objectSpread(_objectSpread({}, station), {}, {
    mainDisplayName: "".concat(station.StationName)
  });
};

exports.formatStationDisplayName = formatStationDisplayName;

var parseSuggestions = function parseSuggestions(results) {
  if (results && results.length > 0) {
    var formattedResults = parseItems(results);
    return formattedResults;
  }

  return [];
};

exports.parseSuggestions = parseSuggestions;

var getDestinationAirportsObject = function getDestinationAirportsObject(allStationsList, destinationObject) {
  var destinationList = [];

  if (allStationsList && (0, _lodash.isArray)(allStationsList) && allStationsList.length > 0) {
    destinationList = allStationsList.filter(function (data) {
      var key = data.StationCode;

      if (Object.prototype.hasOwnProperty.call(destinationObject, key)) {
        // eslint-disable-next-line no-param-reassign
        data.AAFlight = destinationObject[key].AAFlight;
        data.Provider = destinationObject[key].Provider;
        return data;
      }

      return null;
    });
  }

  return destinationList;
};

exports.getDestinationAirportsObject = getDestinationAirportsObject;

var getDestinationAirportsList = function getDestinationAirportsList(data) {
  var destinationObject = {};
  Object.keys(data).map(function (key) {
    Object.keys(data[key]).map(function (item) {
      destinationObject[item] = {
        AAFlight: data[key][item].AAFlight,
        Provider: data[key][item].Provider
      };
      return null;
    });
    return null;
  });
  return destinationObject;
};

exports.getDestinationAirportsList = getDestinationAirportsList;

var getStationObjectFromCode = function getStationObjectFromCode(stationCode) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (data) {
    for (var i = 0; i < data.length; i++) {
      if (data[i].StationCode.toLowerCase() === stationCode.toLowerCase()) {
        return data[i];
      }
    }

    return null;
  }

  return null;
};

exports.getStationObjectFromCode = getStationObjectFromCode;

var getRecentSearches = function getRecentSearches() {
  var searches = localStorage.getItem('recentSearches');

  if (searches != null) {
    searches = JSON.parse(decodeURIComponent(searches));
  }

  return searches;
};

exports.getRecentSearches = getRecentSearches;

var checkIfValidStation = function checkIfValidStation(obj, input) {
  if (!obj || !obj.StationName || !obj.StationCode) return false;
  var st = {
    StationCode: obj.StationCode.toLowerCase()
  };
  return st.StationCode === input;
};

exports.checkIfValidStation = checkIfValidStation;

var fetchStationObject = function fetchStationObject(input, stations) {
  return stations.filter(function (station) {
    var inputLoweCase = input.toLowerCase();
    if (checkIfValidStation(station, inputLoweCase)) return station;
    return null;
  });
};

exports.fetchStationObject = fetchStationObject;